import queryString from 'query-string';

// 是否正在编辑素材
export const isEditTagMaterial = () => {
    const queryParams: any = queryString.parse(window.location.search);

    const { isEmpty, tag_id: queryMaterialId, id, material_id } = queryParams;

    if (isEmpty && (queryMaterialId || material_id) && !id && queryMaterialId !== undefined) {
        return true;
    }

    return false;
};

export const isUploadTemplatePsd = () => {
    const queryParams: any = queryString.parse(window.location.search);

    const { isEmpty, uploadType, from } = queryParams;

    if (isEmpty && uploadType === 'template') {
        return true;
    }

    return false;
};

export const isUploadPPT = () => {
    const queryParams: any = queryString.parse(window.location.search);

    const { isEmpty, uploadType, from } = queryParams;

    if (isEmpty && uploadType === 'ppt') {
        return true;
    }

    return false;
};

export const noUploadTemplatePsdAsEdit = () => {
    const queryParams: any = queryString.parse(window.location.search);

    const { isEmpty, uploadType, from } = queryParams;

    if (isEmpty && uploadType === 'template' && from !== 'hbmb') {
        return true;
    }

    return false;
};

export const isUploadTextMaterialPsd = () => {
    const queryParams: any = queryString.parse(window.location.search);

    const { isEmpty, uploadType, id } = queryParams;

    if (isEmpty && uploadType === 'textMaterial') {
        return true;
    }

    return false;
};

export const isEditMaterial = () => {
    const queryParams: any = queryString.parse(window.location.search);
    const { isEmpty, material_id, tag_id } = queryParams;
    if (isEmpty && material_id && tag_id === undefined) {
        return true;
    }
};

// 是否是ai模板
export const isAITemplate = () => {
    const queryParams: any = queryString.parse(window.location.search);

    const { isAITemplate, id } = queryParams;

    if (isAITemplate && id) {
        return true;
    }

    return false;
};

export const isTextTemplate = () => {
    const queryParams: any = queryString.parse(window.location.search);
    const { isTexMaterialTemplate, id } = queryParams;

    if (id && isTexMaterialTemplate) {
        return true;
    }

    return false;
};

export const isEditorWatermark = () => {
    const queryParams: any = queryString.parse(window.location.search);
    const { isUpdateWatermark, id } = queryParams;

    if (id && isUpdateWatermark) {
        return true;
    }

    return false;
};

export const isUploadWatermark = () => {
    const queryParams: any = queryString.parse(window.location.search);
    const { isUploadWatermark, id } = queryParams;

    if (!id && isUploadWatermark) {
        return true;
    }

    return false;
};

export const isEmptyTextTemplate = () => {
    const queryParams: any = queryString.parse(window.location.search);
    const { type, isEmpty } = queryParams;
    if (isEmpty && type === 'isTexMaterialTemplate') {
        return true;
    }
};

export const isEmptyTemplate = () => {
    const queryParams: any = queryString.parse(window.location.search);
    const { type, isEmpty, id } = queryParams;
    if ((isEmpty && type === 'isTemplate') || (isEmpty && !id && !type)) {
        return true;
    }
};

export const isAiPPT = () => {
    return isUploadAIPPTTemplate() || isEditAIPPTTemplate() || isUploadAIPPTComponent() || isEditAIPPTComponent();
};

export const isUploadAIPPTTemplate = () => {
    const queryParams: any = queryString.parse(window.location.search);
    const { uploadType, isEmpty, isAI } = queryParams;
    if (isEmpty && uploadType === 'ppt' && isAI) {
        return true;
    }
};

export const isEditAIPPTTemplate = () => {
    const queryParams: any = queryString.parse(window.location.search);
    const { isUpdateAIPPTTemplate, id } = queryParams;
    if (isUpdateAIPPTTemplate && id) {
        return true;
    }
};

export const isUploadAIPPTComponent = () => {
    const queryParams: any = queryString.parse(window.location.search);
    const { uploadType, isEmpty, isComponentAI } = queryParams;
    if (isEmpty && uploadType === 'ppt' && isComponentAI) {
        return true;
    }
};

export const isEditAIPPTComponent = () => {
    const queryParams: any = queryString.parse(window.location.search);
    const { isUpdateAIPPTComponent, id } = queryParams;
    if (isUpdateAIPPTComponent && id) {
        return true;
    }
};

// 划重点
export const isEditTextMark = () => {
    const queryParams: any = queryString.parse(window.location.search);
    const { type } = queryParams;

    if (type === 'textMark') {
        return true;
    }

    return false;
};

// 文字特效
export const isEditTextArt = () => {
    const queryParams: any = queryString.parse(window.location.search);
    const { type } = queryParams;

    if (type === 'textArt') {
        return true;
    }

    return false;
};

export const isPPTDemo = () => {
    const queryParams: any = queryString.parse(window.location.search);
    const { isPPTDemo, componentId, templateId } = queryParams;
    if (isPPTDemo) {
        return true;
    }
};

export const isPPTDemoAndShowFullTemplate = () => {
    const queryParams: any = queryString.parse(window.location.search);
    const { isPPTDemo, showComponentList, templateId } = queryParams;
    if (isPPTDemo && !showComponentList && templateId) {
        return true;
    }
};

export const isPPTDemoAndShowComponentList = () => {
    const queryParams: any = queryString.parse(window.location.search);
    const { isPPTDemo, showComponentList, templateId, componentId, smartComponentId } = queryParams;
    if (isPPTDemo && !showComponentList && !templateId && (componentId || smartComponentId)) {
        return true;
    }
};

export const isPPTDemoAndShowTemplateComponentList = () => {
    const queryParams: any = queryString.parse(window.location.search);
    const { isPPTDemo, showComponentList } = queryParams;
    if (isPPTDemo && showComponentList) {
        return true;
    }
};
